import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { PostInputSubmissionResponseDto } from "../../../types/dto/chat/send-input-submission-response-dto";
import { PostInputSubmissionRequestDto } from "../../../types/dto/chat/send-input-submission-request-dto";
import { sendMessageLogSubmission } from "./send-message-log";
import VurbalizeEvents from "../../../types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../../../../application/utils/get-message-by-vurablize-event";
import { setBookAppointment } from "../../theme/theme-slice";
import { BookAppointmentImplementation } from "../../theme/constants/book-appointment-implementation";
import { CONSENT_FLAG_KEY } from "../../../../application/hooks/heartbeat/use-heartbeat";
import Cookies from "js-cookie";
// import getBasicLSData from "../../../../application/utils/getBasicLSData";

export const sendInputSubmission = createAsyncThunk<
  PostInputSubmissionResponseDto,
  { inputLabel: string; value: string }
>(
  "chat-slice/send-input-submission",
  async (
    { inputLabel, value },
    { getState, signal, rejectWithValue, fulfillWithValue, dispatch }
  ) => {
    const state = getState() as RootState;

    const { suId, conversationId, merchId, sessionId } = state["app-state"];
    const { messages } = state["chat"];
    const turnId = messages[messages.length - 1].turn_id;
    const userCountryCode = Cookies.get('userCountryCode');

    // const basicLsData = getBasicLSData();

    const reqBody: PostInputSubmissionRequestDto = {
      cust_id: merchId,
      conversation_id: conversationId,
      turn_id: turnId,
      session_id: sessionId,
      url: window.location.href,
      su_id: suId,
      input_label: inputLabel,
      input_value: value,
      country_iso2_code: userCountryCode || null,
      // ...basicLsData,
      // chat_language: basicLsData.language,
    };

    const response = await axiosClient.post<PostInputSubmissionResponseDto>(
      "/inputsubmission",
      reqBody, {
        signal
      }
    );
    if (response.status !== HttpStatusCode.Ok) {
      // Return the known error for future handling
      return rejectWithValue(response.data);
    }

    const responseData = response.data;

    if (responseData.consent_flag) {
      localStorage.setItem(CONSENT_FLAG_KEY, 'true');
    }

    dispatch(setBookAppointment({
      implementation: BookAppointmentImplementation.HUBSPOT,
      details: {
        link: responseData?.calendar_event?.meeting_link,
        contactOwnerEmail: responseData?.calendar_event?.contact_owner_email,
        userDetails: {
          email: responseData?.calendar_event?.user_details?.email,
          firstname: responseData?.calendar_event?.user_details?.firstname,
          lastname: responseData?.calendar_event?.user_details?.lastname
        }
      },
    }));

    dispatch(sendMessageLogSubmission({
      data: {
        input_label: inputLabel,
        message: getMessageByVurablizeEvent(VurbalizeEvents.INPUT_PROVIDED, value.trim()),
        event_name: VurbalizeEvents.INPUT_PROVIDED,
        event_data: {
          timestamp: Date.now(),
          inputType: "email",
          inputContent: value,
        },
      },
    }));

    return fulfillWithValue(response.data);
  }
);
